// extracted by mini-css-extract-plugin
export default {"loader":"ComponentLoader_loader__-wNWw"};